<template>
  <div class="scorllPlace">
    <div @touchend="moveEnd" @touchmove="moveImg" @touchstart="starMove" :id="randomId + '-imgPlace'" class="scorllImgHidden">
      <div class="dotPlace">
        <div :key="index" :class="nowIndex === index ? 'active' : ''" v-for="(item, index) in newImgList"></div>
      </div>
      <div>
        <img class="cardmoveImg" data-trans="0" :src="item" :key="index" width="100%" v-for="(item, index) in newImgList" />
      </div>
    </div>
    <img :src="item" :key="index" style="width: 0;height: 0" v-for="(item, index) in newImgList" />
  </div>
</template>

<script>
let pageX = 0
let canMove = true
export default {
  name: 'page',
  props: [
    'imgList'
  ],
  data () {
    return {
      randomId: new Date().getTime() + Math.random() * 9999,
      nowIndex: 0,
      newImgList: this.imgList,
      imgWidth: 0,
      scorllPlaceWidth: 0
    }
  },
  created () { // vue 页面的生命周期 当我一进来页面之后 我先执行

  },
  mounted () { // vue 页面的生命周期 当我进来之后 且加载完资源了之后再执行
  },
  methods: { // 所有的方法封装
    starMove (e) {
      pageX = e.touches[0].clientX
    },
    moveImg (e) {
      let dom = document.getElementById(this.randomId + '-imgPlace')
      let domList = dom.querySelectorAll('img')
      this.scorllPlaceWidth = dom.clientWidth * 0.05
      this.imgWidth = domList[0].clientWidth + 15
      for (let i = 0; i < domList.length; i++) {
        let nowtrans = parseInt(domList[i].getAttribute('data-trans'))
        if ((nowtrans + e.touches[0].clientX - pageX) < 0 && (nowtrans + e.touches[0].clientX - pageX) > 0 - (this.imgWidth * (this.newImgList.length - 1))) {
          canMove = true
          domList[i].style.transform = 'translateX(' + (nowtrans + e.touches[0].clientX - pageX) + 'px)'
        } else {
          canMove = false
        }
      }
    },
    moveEnd (e) {
      if (canMove) {
        let dom = document.getElementById(this.randomId + '-imgPlace')
        let domList = dom.querySelectorAll('img')
        for (let i = 0; i < domList.length; i++) {
          domList[i].style.transition = 'all 0.3s'
        }
        setTimeout(p => {
          for (let i = 0; i < domList.length; i++) {
            domList[i].style.transition = 'width 0.3s'
          }
        }, 300)
        if (Math.abs(e.changedTouches[0].clientX - pageX) > 30) {
          if (e.changedTouches[0].clientX > pageX) {
            for (let i = 0; i < domList.length; i++) {
              let nowtrans = parseInt(domList[i].getAttribute('data-trans'))
              domList[i].style.transform = 'translateX(' + (nowtrans + this.imgWidth) + 'px)'
              domList[i].setAttribute('data-trans', nowtrans + this.imgWidth)
            }
            this.nowIndex--
            if (this.nowIndex < 0) {
              this.nowIndex = 0
            }
          } else {
            for (let i = 0; i < domList.length; i++) {
              let nowtrans = parseInt(domList[i].getAttribute('data-trans'))
              domList[i].style.transform = 'translateX(' + (nowtrans - this.imgWidth) + 'px)'
              domList[i].setAttribute('data-trans', nowtrans - this.imgWidth)
            }
            this.nowIndex++
            if (this.nowIndex === this.newImgList.length) {
              this.nowIndex = this.newImgList.length - 1
            }
          }
        } else {
          for (let i = 0; i < domList.length; i++) {
            let nowtrans = parseInt(domList[i].getAttribute('data-trans'))
            domList[i].style.transform = 'translateX(' + nowtrans + 'px)'
          }
        }
      }
    }
  },
  components: {
  },
  watch: {
    imgList (value) {
      this.newImgList = value
    }
  }
}
</script>

<style scoped>
  .scorllPlace {
    width: 100%;
    overflow: hidden;
    position: relative;
  }
  .scorllPlace .cardmoveImg{
    width: calc(100% - 60px);
  }
  .scorllPlace .cardmoveImg:nth-child(1) {
    margin-left: 30px;
  }
  .scorllPlace .cardmoveImg:not(:nth-child(1)) {
    margin-left: 15px;
  }
  .scorllImgHidden{
    white-space: nowrap;
    left: 0;
    position: relative;
  }
  .dotPlace{
    position: absolute;
    z-index: 2;
    bottom: 5%;
    width: 100%;
    text-align: center;
  }
  .dotPlace > div{
    display: inline-block;
    width: 5px;
    margin: 0 3px;
    height: 5px;
    opacity: 0.8;
    border-radius: 5px;
    transition: all 0.3s;
    background-color: #fff;
  }
  .dotPlace > div.active{
    width: 10px;
    background-color: #4A85E8;
  }

</style>



// WEBPACK FOOTER //
// src/components/myComponents/cardScorll.vue